<div class="container mt-3 mx-auto">
    <div class="alert alert-info" *ngIf="!janelas || !janelas.length">
        Não foram encontradas janelas de atualização com os filtros informados.
    </div>

    <div *ngIf="janelas && janelas.length">

        <bn-paginacao
            [total]="atributosPaginacao.count"
            [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
            [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">


            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th id="col-data-abertura" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'dataAbertura'"
                                    [nomeAtributoExibicao]="'Data Abertura'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-data-fechamento" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'dataFechamento'" 
                                    [nomeAtributoExibicao]="'Data fechamento'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                        
                            <th id="col-tipo-janela" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'tipoJanela'" 
                                    [nomeAtributoExibicao]="'Tipo Janela'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            <th id="col-modalidade" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'modalidade'" 
                                    [nomeAtributoExibicao]="'Modalidade Garantia'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            <th></th>
                            <th *ngIf="podeIncluirNovaJanela"></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let janela of janelas">
                            <td>{{ janela.dataAbertura | date: 'dd/MM/yyyy' }}</td>
                            <td>{{ janela.dataFechamento | date: 'dd/MM/yyyy' }}</td>
                            <td>{{ nomeTipoJanela(janela.tipoJanela) }}</td>
                            <td>{{ janela.modalidadeGarantia }}</td>
                            <td><a [routerLink]="['/janelas-atualizacao-info', janela.id]" >
                                <i [class]=" podeIncluirNovaJanela ? 'fa fa-pencil' : 'fa fa-search'" aria-hidden="true" 
                                   placement="left-top" [ngbTooltip]=" podeIncluirNovaJanela ? 'Editar Janela' : 'Visualizar Janela'">    
                                </i></a>
                            </td> 
                            <td *ngIf="podeIncluirNovaJanela"><a href="javascript:void(0)" bnConfirm tituloConfirm="Confirmação" msgConfirm="Tem certeza de que deseja excluir a janela?"
                                (onConfirm)="excluirJanela(janela.id)" >
                                <i class="fa fa-trash" aria-hidden="true" 
                                   placement="left-top" ngbTooltip="Excluir Janela">    
                                </i></a>
                            </td> 
                        </tr>
                    </tbody>

                </table>
            </div>
        </bn-paginacao>
    </div>
</div>